import React from "react";
//Limitless imports
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
import { useTranslation } from "@limitless/common/hooks";
export const useExpertWebNotificationHook = () => {
  const [windowIsActive, setWindowIsActive] = React.useState(true);
  const [badgeCount, setBadgeCount] = React.useState(0);
  const {
    t
  } = useTranslation();
  const {
    profile
  } = useExpertProfileContext();
  React.useEffect(() => {
    if (process.env.REACT_APP_TYPE !== "mobile") {
      const handleActivityFalse = () => handleActivity(false);
      const handleActivityTrue = () => handleActivity(true);
      document.addEventListener("visibilitychange", handleActivity);
      document.addEventListener("blur", handleActivityFalse);
      window.addEventListener("blur", handleActivityFalse);
      window.addEventListener("focus", handleActivityTrue);
      document.addEventListener("focus", handleActivityTrue);
      return () => {
        window.removeEventListener("blur", handleActivity);
        document.removeEventListener("blur", handleActivityFalse);
        window.removeEventListener("focus", handleActivityFalse);
        document.removeEventListener("focus", handleActivityTrue);
        document.removeEventListener("visibilitychange", handleActivityTrue);
      };
    }
  }, []);
  React.useEffect(() => {
    if (windowIsActive) {
      setBadgeCount(0);
    }
  }, [windowIsActive]);
  React.useEffect(() => {
    if (process.env.REACT_APP_TYPE !== "mobile") {
      const title = "--- Limitless ---";
      if (badgeCount > 0) {
        const newTitle = `(${badgeCount}) ${title}`;
        document.title = newTitle;
      } else {
        document.title = title;
      }
    }
  }, [badgeCount]);
  const handleActivity = forcedFlag => {
    if (typeof forcedFlag === "boolean") {
      return forcedFlag ? setWindowIsActive(true) : setWindowIsActive(false);
    }
    return document.hidden ? setWindowIsActive(false) : setWindowIsActive(true);
  };
  const sendBrowserNotification = () => {
    if ("Notification" in window && Notification.permission === "granted" && !windowIsActive && profile.receiveBrowserTaskNotifications) {
      const notification = new Notification(t("There is new activity in your task list"), {
        icon: "https://play-lh.googleusercontent.com/FAcU1mg6KdAuU9ujv8x4Xr7EsROhusVzrY3ndwUrAjDR3jLkUAAtr1URlDzgnsf3rRE"
      });
      notification.onclick = function () {
        window.focus();
      };
      setBadgeCount(badgeCount + 1);
    }
  };
  return {
    sendBrowserNotification
  };
};